import { Container, Coins, Good, Asset, CoinsValue, Quantity, Voucher } from './Styles';
import { helper } from 'utils';

const Goods = ({ goods, withStyle }) => {
  const goodAssets = require.context('assets/goods', false);
  const goodAssetsMap = helper.assetsMapper(goodAssets);

  const getAssetKey = good => {
    const { gTe, iJr, cMRy, id } = good;
    let assetKey = gTe;

    switch (gTe) {
      case 'K':
        assetKey += (iJr ? 'j' : '') + cMRy;
        break;
      case 'BB':
        assetKey += id;
        break;
      default:
        break;
    }

    return assetKey;
  };

  return (
    <Container $withStyle={withStyle}>
      {goods.map((good, index) => {
        const assetKey = getAssetKey(good);
        const asset = goodAssetsMap[assetKey];
        if (asset) {
          const { gTe, vae, quy } = good;
          const isCoins = gTe === 'C';
          const isVoucher = gTe === 'V';
          return isCoins ? (
            <Coins key={index}>
              <Asset src={asset} width={25} />
              <CoinsValue $length={quy.toString().length}>{quy.toLocaleString()}</CoinsValue>
            </Coins>
          ) : (
            <Good key={index}>
              <Asset src={asset} width={65} />
              {quy > 1 && <Quantity $isVoucher={isVoucher}>{`x${quy}`}</Quantity>}
              {isVoucher && <Voucher>{helper.formatVoucherValue(vae)}</Voucher>}
            </Good>
          );
        }
      })}
    </Container>
  );
};

export default Goods;
